<template>
  <div class="aboutUs">
    <MdAboutUs  class="MD"/>
    <PcAboutUs class="PC"/>
  </div>
</template>

<script>
// 引入根路径
import request from '@/utils/request'
// 移动端
import MdAboutUs from './MdAboutUsNew.vue'
// pc端
import PcAboutUs from './PcAboutUsNew.vue'
// 合作伙伴
import { getCooperative } from '@/api/aboutUs'

export default {
  name: 'aboutUs',
  components: {
    MdAboutUs,
    PcAboutUs
  },
  data () {
    return {
      baseURL: '',
      aboutFellows: [] // 合作伙伴
    }
  },
  created () {
    this.getCooperative()
    this.baseUrl = request.defaults.baseURL
  },
  methods: {
    // 获取合作伙伴
    async getCooperative () {
      // 写死一个
      const res = await getCooperative({ PageSize: 8, PageIndex: 1 })
      // console.log(res, '合作伙伴')
      if (res.Msg === '获取成功') {
        this.aboutFellows = res.Data.DataList
        this.aboutFellows.forEach(item => {
          item.ImgUrl = request.defaults.baseURL + item.ImgUrl
        })
        this.$store.commit('getAboutFellows', this.aboutFellows)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .aboutUs{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .aboutUs{
    .MD{
      display: none;
    }
  }
}
</style>
